module.exports = __webpack_public_path__ + "img/材料力学6_4_4.3b23ca9d.jpg";